import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { registerUser } from "../../../auth";

export const FETCH_DATA_SIGNUP_REQUEST = 'FETCH_DATA_SIGNUP_REQUEST';
export const FETCH_DATA_SIGNUP_SUCCESS = 'FETCH_DATA_SIGNUP_SUCCESS';
export const FETCH_DATA_SIGNUP__FAILURE = 'FETCH_DATA_SIGNUP__FAILURE';
export const SIGNUP = 'SIGNUP';
export const CLEAR_DATA = 'CLEAR_DATA';

interface ActionDefault<T> {
    type: string,
    payload: T
}

interface ActionPagination<T> {
    type: string,
    payload: T
}

export const clear = ()=>{
    return {
        type: CLEAR_DATA,
    };  
}

const signupDataRequest = () => {
    return {
        type: FETCH_DATA_SIGNUP_REQUEST,
    };
};

const signupDataSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_SIGNUP_SUCCESS,
        payload: data
    };
};

const signupDataFailure = (error: any) => {
    return {
        type: FETCH_DATA_SIGNUP__FAILURE,
        payload: error,
    };
};

export const signup = (data: any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(signupDataRequest());
        try {
            const response = await registerUser(data);
            dispatch(signupDataSuccess(response.data));
        } catch (error: any) {
            dispatch(signupDataFailure(error.response));
        }
    };
};